import React from 'react';
import * as AuthActions from 'core/services/store/auth/actions';
import { $ } from '@starberry/components';
import { EmailIcon } from '@chakra-ui/icons';
import { Stack, InputGroup, FormControl, Alert, AlertIcon, AlertTitle } from '@chakra-ui/react';
import { useCallback, useContext } from 'react';
import { useModule } from '@starberry/components';
import AuthServices from 'core/services/store/auth/services';
import { AuthContext } from 'core/services/index';

function ForgetPassForm({ ALERT_SUCCESS, ALERT_ERROR, borderRadius, children }) {
  const [state, dispatch] = useContext(AuthContext);

  const handleEmailChange = useCallback((e) => {
    dispatch?.(AuthActions.setFormField('email', e.target.value));
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      AuthServices(dispatch, AuthActions).forgottenPassword({
        email: state?.form?.email,
      });
    },
    [dispatch, state?.form?.email]
  );

  const InputField = useModule('InputField') ?? null;

  return (
    <form key="reset-form" flex={1} onSubmit={handleSubmit}>
      <Alert
        status="success"
        display={state?.success ? 'flex' : 'none'}
        mb={state?.error ? 6 : 0}
        borderRadius={borderRadius}
      >
        <AlertIcon />
        <AlertTitle mr={2}>{ALERT_SUCCESS}</AlertTitle>
      </Alert>
      <Alert
        status="error"
        display={state?.error ? 'flex' : 'none'}
        mb={state?.error ? 6 : 0}
        borderRadius={borderRadius}
      >
        <AlertIcon />
        <AlertTitle mr={2}>{ALERT_ERROR}</AlertTitle>
      </Alert>
      <Stack spacing={6}>
        <InputGroup>
          <FormControl id="email" key="email">
            <InputField
              name="email"
              type="email"
              autocomplete="email"
              placeholder="email"
              label="Email address"
              required={true}
              rightIcon={() => EmailIcon}
              onChange={() => handleEmailChange}
            />
          </FormControl>
        </InputGroup>
        {children}
      </Stack>
    </form>
  );
}

export default {
  provide: ['auth'],
  submitButton: {
    $: 'PrimaryButton',
    type: 'submit',
    children: $('constants.translations.resetPassEmail.FORGET_SUBMIT_BTN', 'Reset Password'),
  },
  children: {
    component: React.memo(ForgetPassForm),
    props: {
      ALERT_SUCCESS: $(
        'constants.translations.resetPassEmail.ALERT_SUCCESS',
        'Please check your Inbox to reset your password'
      ),
      ALERT_ERROR: $(
        'constants.translations.resetPassEmail.ALERT_ERROR',
        'The provided email address is invalid'
      ),
      borderRadius: $('constants.input.borderRadius'),
    },
    children: $('submitButton'),
  },
};
